import React from "react";
import Col from "react-bootstrap/Col";

export function Field({ label, error, required, children, md = 6, lg = 4 }) {
  return (
    <Col xs={12} md={md} lg={lg} className="mb-3">
      <label className="form-label">
        {label}
        {required ? <span className="accounts-req"> *</span> : null}
      </label>
      {children}
      {error ? <div className="invalid-feedback d-block">{error}</div> : null}
    </Col>
  );
}

export function controlClass(error, extra = "") {
  return `form-control${extra ? ` ${extra}` : ""}${error ? " is-invalid" : ""}`;
}

export function selectClass(error) {
  return `form-select${error ? " is-invalid" : ""}`;
}
